import React, { Component } from 'react';

export default class IClickerCourseCreateRedirectPage extends Component {
  componentDidMount() {
    try {
      const params = new URLSearchParams(window.location.search);
      window.parent.window.Gradebook.closeIClickerCreateScreen(
        params.get('iClickerCourseId'),
      );
    } catch (_e) {
      window.location = window.location.origin;
    }
  }

  render() {
    /* Don't import CSS so we can save on loading time. */
    /* Don't import spinner so we can save on loading time. */
    return <span style={{ padding: '20px' }}>Loading...</span>;
  }
}
